import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import styles from './style.module.scss'
import { addAdsInsideParagraph, addEditorAds, checkIsGlanceView } from '@shared/utils'
// import { refreshGoogleAds } from '@shared/libs/ads'
const AdsPortal = dynamic(() => import('@shared/components/adsPortal'), { ssr: false })
const Ads = dynamic(() => import('@shared/components/ads'))
const ArrayHTML = dynamic(() => import('@shared/components/InnerHTML/arrayHTML'))
const InnerHTML = dynamic(() => import('@shared/components/InnerHTML'))
const CommonContent = dynamic(() => import('@shared/components/commonContent'))

const InfoBlock = (props) => {
  const router = useRouter()
  const isGlanceView = checkIsGlanceView(router?.query)
  const isMobileWebView = router?.query?.isMobileWebView

  const adsData = useMemo(() => {
    if (!isGlanceView && !isMobileWebView) {
      return [
        {
          id: 'gt-ads-1',
          component: (
            <Ads
              id="div-ad-gpt-138639789-1660131756-0"
              adIdDesktop="Crictracker_New_Desktop_AP_MID_728x90"
              adIdMobile="Crictracker_New_Mobile_AP_MID1_300x250"
              dimensionDesktop={[728, 90]}
              dimensionMobile={[300, 250]}
              mobile
              slotId="23148549803"
              className={'text-center d-none d-md-block'}
            />
          )
        },
        {
          id: 'gt-ads-2',
          component: (
            <Ads
              id="div-ad-gpt-138639789-1660131756-1"
              adIdDesktop="Crictracker_New_Desktop_AP_BTF_728x90"
              adIdMobile="Crictracker_New_Mobile_AP_MID2_300x250"
              dimensionDesktop={[728, 90]}
              dimensionMobile={[300, 250]}
              mobile
              slotId="23148549803"
              className={'text-center d-none d-md-block'}
            />
          )
        }
      ]
    } else return []
  }, [])

  return (
    <div className={`${styles.infoBlock} common-section pb-0 ${props?.className}`} id={props?.id}>
      <AdsPortal adsData={adsData} />
      <p className={`${props?.fantasystyles?.itemTitle} text-primary fw-bold text-uppercase`}>{props?.title}</p>
      {typeof props?.info === 'object' && props?.info instanceof Array ? (
        <CommonContent>
          <ArrayHTML data={props?.info} article={props?.article} />
        </CommonContent>
      ) : (
        <InnerHTML className={`${props?.fantasystyles?.infoDesc} big-text`} html={addEditorAds(addAdsInsideParagraph(props?.info, [0]))} />
      )}
    </div>
  )
}

InfoBlock.propTypes = {
  fantasystyles: PropTypes.any,
  title: PropTypes.any,
  info: PropTypes.any,
  id: PropTypes.string,
  className: PropTypes.string,
  article: PropTypes.object
}

export default InfoBlock
